import {AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {MatDialog, MatSort, MatTableDataSource, PageEvent, Sort} from '@angular/material';
import {ModalDelegationComponent} from '../modal-delegation/modal-delegation.component';
import {SelectionModel} from '@angular/cdk/collections';
import {ModalEditDelegationComponent} from '../modal-edit-delegation/modal-edit-delegation.component';
import {DelegationService} from '../delegation.service';
import {AuthService} from '../../../auth/services/auth.service';
import {environment} from '../../../../environments/environment';
import {TranslateService} from '@ngx-translate/core';
import {Delegate} from '../../../model/delegationUo';
import {Router} from '@angular/router';
import {SearchPipe} from '../../../pipe/search.pipe';
import {DelegationList} from '../../../model/delegationList';
import * as moment from 'moment';
import {LiveAnnouncer} from '@angular/cdk/a11y';
import {ModalDeleteDelegationComponent} from '../modal-delete-delegation/modal-delete-delegation.component';

@Component({
    selector: 'app-delegation-list',
    templateUrl: './delegation-list.component.html',
    styleUrls: ['./delegation-list.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class DelegationListComponent implements OnInit, AfterViewInit {

    searchDelegate = '';
    showOldDelegation = false;

    closeBlockNotification = false;
    showCurrentDelegation = true;
    selection = new SelectionModel<any>(true, []);

    matricule = '';
    dataSource = new MatTableDataSource<any>([]);
    numberNotification = 0;
    dataFiltred: any[] = [];
    displayedColumns = ['select', 'user', 'uo', 'authorization', 'authorizationDuration', 'function', 'action'];
    uoAndUsers: any;
    length = 0;
    pageSize = 20;
    pageIndex = 0;
    pageSizeOptions = [20, 30, 40];

    hidePageSize = false;
    showPageSizeOptions = true;
    showFirstLastButtons = true;
    disabled = false;

    pageEvent: PageEvent;
    delegationDeleted: any;
    @ViewChild(MatSort) sort: MatSort;

    constructor(private router: Router,
                private searchPipe: SearchPipe,
                private _liveAnnouncer: LiveAnnouncer,
                public translateService: TranslateService, private delegationService: DelegationService, private auth: AuthService, private _formBuilder: FormBuilder, public dialog: MatDialog) {
    }

    ngOnInit() {
        this.matricule = JSON.parse(localStorage.getItem(environment.oauth.remoteUser)).userName;
        this.getDelegations(this.matricule, false);
        this.loadUoAndUsers(this.matricule);
        this.totalDelegationsExpiringSoon(this.matricule);
        this.displayedColumns = this.displayedColumns.filter(e => e !== 'select');

        this.selection.onChange.subscribe(() => {
            const selections: any = this.selection.selected;
            console.log('selections : ', selections);

        });

    }

    addNewDelegation() {
        const data: Delegate = new Delegate();
        data.matricule = this.matricule;
        data.uoAndUsers = this.uoAndUsers;
        this.dialog.open(ModalDelegationComponent, {
            data: data,
            panelClass: 'cdk-modal-injection',
            /*disableClose: true*/
        });
    }

    masterToggle() {
        this.isAllSelected() ?
            this.selection.clear() :
            this.dataSource.data.forEach(row => this.selection.select(JSON.stringify(row)));

    }

    isSelected(row) {
        return this.selection.isSelected(JSON.stringify(row));
    }

    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this.dataSource.data.length;
        return numSelected === numRows;
    }

    deleteDelegationPopup(row) {
        console.log('element : ', row);
        this.delegationDeleted = row;
        this.dialog.open(ModalDeleteDelegationComponent, {
            width: '335px',
            height: '450px',
            data: {
                delegator: row
            }
        });
    }

    editDelegationPopup(row) {
        console.log('ele : ', row);
        this.dialog.open(ModalEditDelegationComponent, {
            width: '503px',
            height: '713px',
            data: {
                delegator: row
            }
        });
    }

    toggleSelect(row) {
        console.log('JSON.stringify(row) : ', JSON.stringify(row));
        console.log('this.selection : ', this.selection);
        this.selection.toggle(JSON.stringify(row));
    }

    getDelegations(matricule: string, showOldDelegation: boolean) {
        this.delegationService.getDelegations(matricule, showOldDelegation, this.pageIndex, this.pageSize).subscribe(res => {
            console.log('reee : ', res);
            this.dataSource.data = res.content;
            this.length = res.totalElements;
            this.dataFiltred = res.content;
        });
    }

    search(search: any) {
        console.log('search : ', search);
        if (!search || search == '') {
            this.dataSource.data = this.dataFiltred;
        } else {
            this.dataSource.data = this.searchPipe.transform(this.dataFiltred, search, ['fullName', 'delegate', 'function', 'delegationHabilitation']);
        }
    }

    showOldOrPendingDelegation(fromOldDelegationPage: boolean) {
        if (fromOldDelegationPage) {
            this.showOldDelegation = true;
            this.showCurrentDelegation = false;
            this.pageSize = 7;
            this.pageIndex = 0;
            this.getDelegations(this.matricule, this.showOldDelegation);
        } else {
            this.showCurrentDelegation = true;
            this.showOldDelegation = false;
            this.pageSize = 7;
            this.pageIndex = 0;
            this.getDelegations(this.matricule, this.showOldDelegation);
        }
    }

    loadUoAndUsers(matricule: string) {
        this.delegationService.loadAllDelegation(matricule).subscribe(res => {
            this.uoAndUsers = res;
        });
    }

    checkDelegationExpiryAfter5Day(element: DelegationList) {

        if (this.showOldDelegation) {
            return false;
        }
        if (element && element.delegationHabilitation) {
            const endDate = moment(element.delegationHabilitation.endDate);
            const today = moment(new Date());
            return endDate.diff(today, 'days') <= 4;
        }


        return true;
    }

    getDelegationExpiryDay(element: DelegationList) {

        if (this.showOldDelegation) {
            return false;
        }
        if (element && element.delegationHabilitation) {
            const endDate = moment(element.delegationHabilitation.endDate);
            return endDate.diff(moment(new Date()), 'days');
        }


        return 0;
    }

    handlePageEvent(e: PageEvent) {
        this.pageEvent = e;
        this.length = e.length;
        this.pageSize = e.pageSize;
        this.pageIndex = e.pageIndex;
        this.getDelegations(this.matricule, this.showOldDelegation);
    }

    getBackgroundColor(row, i) {
        if (!row.deleted && this.showOldDelegation) {
            return 'rgb(158 158 158 / 77%)';
        }
        return i % 2 == 0 ? '#fff' : '#F5F5F5';
    }

    ngAfterViewInit() {
        this.dataSource.sort = this.sort;
    }

    /** Announce the change in sort state for assistive technology. */
    announceSortChange(sortState: Sort) {
        // This example uses English messages. If your application supports
        // multiple language, you would internationalize these strings.
        // Furthermore, you can customize the message to add additional
        // details about the values being sorted.
        if (sortState.direction) {
            this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
        } else {
            this._liveAnnouncer.announce('Sorting cleared');
        }
    }

    private totalDelegationsExpiringSoon(matricule: string) {
        this.delegationService.totalDelegationsExpiringSoon(matricule)
            .subscribe(total => this.numberNotification = total);
    }

}



// WEBPACK FOOTER //
// ./src/app/modules/delegation/delegation-list/delegation-list.component.ts